import { combineReducers } from 'redux';

import { fetchBills } from '../sagas/bills/actions';
import { changeCurrentDevice } from '../components/Header/actions';

const bills = (state = [], action) => {
  if (action.type === fetchBills.done.type) {
    return action.payload.result.data;
  }
  if (action.type === changeCurrentDevice.type) {
    return {};
  }
  return state;
};

const hasNewBills = (state = false, action) => {
  if (action.type === fetchBills.done.type) {
    return action.payload.result.data.length > 0;
  }
  if (action.type === changeCurrentDevice.type) {
    return false;
  }
  return state;
};

export default combineReducers({
  bills,
  hasNewBills,
});



// WEBPACK FOOTER //
// ./src/reducers/bills.js